<template>
  <b-container fluid id="user-profile" class="d-flex"
  style="top: 10px; z-index: 1; height: calc(100vh - 20px);">
    <div class="border text-left" style="width: 300px;">
        <router-link
        :to="`/settings/account`"
       >
        <b-button
            variant="link"
            block
            class="text-gray-600 text-left"
            style="text-decoration: none !important;"
        >Account Settings</b-button>
      </router-link>
       <router-link v-if="isAuthorized"
        :to="`/settings/roles`"
       >
        <b-button
          variant="link"
          block
          class="text-gray-600 text-left"
          style="text-decoration: none !important;"
        >Manage Roles</b-button>
      </router-link>
      <router-link v-if="isAuthorized"
        :to="`/settings/office`"
       >
        <b-button
          variant="link"
          block
          class="text-gray-600 text-left"
          style="text-decoration: none !important;"
        >Manage Office</b-button>
      </router-link>
    </div>
    <div class="position-relative w-100">
      <transition :name="transitionName">
        <router-view v-cloak/>
      </transition>
    </div>
  </b-container>
</template>

<script>

export default {
  name: 'Setting',
  computed: {
    isAuthorized() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user.roles === 'Admin' || user.roles === 'Owner';
    },
  },
};
</script>

<style>
html {
  scroll-behavior: smooth;
}
</style>

<style scoped lang="scss">
#table-of-contents {
  background: transparent;
}

#table-of-contents .list-group-item {
  background-color: inherit;
  border: none;
  transition: all .2s ease;
  color: black;
}

#table-of-contents .list-group-item:before {
  transition: all .2s ease;
  content: '';
  position: absolute;
  top: 12.5%;
  left: 0;
  background: transparent;
  height: 75%;
  width: 5px;
  border-radius: 5px;
}

#table-of-contents .list-group-item.active:before {
  transition: all .2s ease;
  background: var(--secondary-color);
}

#table-of-contents .list-group-item:hover {
  transition: all .2s ease;
  color: #676767 !important;
  background: #e5eef1;
  border-radius: 0.25rem;
}

#table-of-contents .list-group-item:hover:before {
  transition: all .2s ease;
  background: #a2c3e0;
}

::v-deep .settings-button {
  padding: 10px 0;
  color: black;
}

::v-deep.settings-button:hover {
  background: #f5f5f5;
  border-radius: 0;
}
::v-deep .normalize {
  outline: none;
  box-shadow: none;
  background-color: transparent;
  border: none;
  padding-left: 0;
  padding-right: 0;
}

.component-fade-enter-active, .component-fade-leave-active {
  transition: all .15s ease;
  transform: scale(1);
}
.component-fade-enter, .component-fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
